<template>
  <!-- title level 1 -->
  <title-component title="Acerca de esta app" />
  <!-- content  level 1 -->
  <div class="ml-[20px]">
    <p
      class="text-[12px] lg:text-[14px] capitalize text-initial text-justify"
      style="white-space: pre-line"
    >
      LIMA es una nueva forma de encontrar espacios disponibles para ti, de la
      forma más rápida y eficiente. <br />
      <br />
      Con LIMA puedes reservar desde un parqueo para tu vehículo en un día
      ajetreado en tu ciudad, pasando por una piscina cerca de ti en un día
      caluroso, hasta un espacio de trabajo profesional y empezar tu proyecto.`,
    </p>
    <!-- title level 2 -->
    <div v-for="(item, index) in info" :key="index">
      <sub-title-component :title="item.title" />
      <!-- content  level 2 -->
      <div class="ml-[20px]">
        <p
          class="text-[12px] lg:text-[14px] capitalize text-initial text-justify"
          style="white-space: pre-line"
        >
          {{ item.paragraph }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import TitleComponent from '@/components/titles/Title.vue';
import SubTitleComponent from '@/components/titles/SubTitle.vue';
export default {
  components: { TitleComponent, SubTitleComponent },
  name: 'AboutPage',
  data() {
    return {
      info: [
        {
          title: 'Anfitriona.',
          paragraph: `Con lima tienes la opción de ser un anfitrión y generar dinero con un espacio, que ya tienes, imagina generar ingresos extra con ese garaje o piscina que tienes, que esperas descarga la app y únete a nuestra comunidad.`,
        },
        {
          title: 'Estacionamiento.',
          paragraph: `Sabemos lo importante que es para ti llegar a tiempo a ese concierto que tanto esperaste, o a esa cita especial o esa reunión tan importante con tu jefe, no te preocupes más por batallar encontrando estacionamiento LIMA lo hace por ti.`,
        },
        {
          title: 'Espacios de entretenimiento.',
          paragraph: `Encontrar una opción para desestresarse nunca fue más fácil, nosotros lo tenemos cubierto, en LIMA puedes encontrar desde piscinas, trampolines, mesas de billar, hasta salones para fiestas o jardines, para realizar ese evento que quieras con tus seres queridos.`,
        },
        {
          title: 'Espacios de almacenamiento.',
          paragraph: `Que el almacenaje jamás vuelva a ser un problema, ése producto, esos muebles que no caben después de la mudanza, ésas maletas en ese viaje corto, encuentra en LIMA un espacio para almacenar a tu conveniencia.`,
        },
        {
          title: 'Espacios de trabajo',
          paragraph: `Tienes un proyecto en mente, pero no sabes dónde empezar que tal reservar en LIMA, ése lugar solo cuando lo necesites, ese despacho jurídico, ese salón de belleza, esa oficina profesional para reuniones con tu equipo. LIMA lo resuelve por ti

          Descarga LIMA ahora, únete a nuestra comunidad y hagamos este mundo un espacio mejor.`,
        },
      ],
    };
  },
};
</script>

<style></style>
